import { FlexComponent, ModuleDefinition } from "src/typings/flexFramework/FlexComponent";
import { BlossomComponent } from "components/flexFramework/domain/BlossomComponent";
import { BlossomComponentFromComposition } from "components/flexFramework/domain/BlossomComponentFromComposition";
import { BlossomComponentFromTemplate } from "components/flexFramework/domain/BlossomComponentFromTemplate";

export interface BlossomComponentFactoryProps {
  flexComponent?: FlexComponent;
  moduleDefinition?: ModuleDefinition;
}

/**
 * Factory that helps get Blossom Component based on the given props
 */
export class BlossomComponentFactory {
  public static get = (props: BlossomComponentFactoryProps): BlossomComponent | null => {
    if (!props) {
      return null;
    }

    if (props.moduleDefinition) {
      return new BlossomComponentFromTemplate(props.moduleDefinition);
    }

    if (props.flexComponent) {
      return new BlossomComponentFromComposition(props.flexComponent);
    }

    return null;
  };
}
